import React from "react";

const ActiveLoanCard = ({
  data,
  onViewDetails,
  onDownloadAgreement,
  loanId,
  loanAmount,
  totalPayable,
  amountPaid,
  outstandingAmount,
  icon,
  downloadIcon,
  disableViewBtn,
  loanAgreementId
}) => {
  // Calculate percentage for progress bar
  let percentage = 0;
  const parseAmount = (val) => {
    if (!val) return 0;
    if (typeof val === 'number') return val;
    // Remove currency symbols and commas
    const parsed = parseFloat(String(val).replace(/[^0-9.-]+/g, ""));
    return isNaN(parsed) ? 0 : parsed;
  };

  const numAmountPaid = parseAmount(amountPaid);
  const numTotalPayable = parseAmount(totalPayable);

  if (numTotalPayable > 0) {
    percentage = Math.round((numAmountPaid / numTotalPayable) * 100);
    if (percentage > 100) percentage = 100;
  }

  // Fallback to empty string or 0 if values are missing
  const displayLoanId = loanId || data?.loan_Id || "-";
  const displayLoanAmount = loanAmount || data?.loan_amount || "₹0";
  const displayTotalPayable = totalPayable || data?.total_payable || "₹0";
  const displayAmountPaid = amountPaid || data?.amount_paid || "₹0";
  const displayOutstanding = outstandingAmount || data?.outstanding || "₹0";

  return (
    <div className="active-loan-card">
      {/* Header */}
      <div className="header-section">
        <div className="left-content">
          <div className="icon-container">
            {icon && <img src={icon} alt="Loan Icon" />}
          </div>
          <div className="text-content">
            <h4>Active Loan</h4>
            <p>Your current loan summary</p>
          </div>
        </div>
        <div className="right-content">
          {(onDownloadAgreement || (data && data.loan_agreement)) && (
            <button
              onClick={onDownloadAgreement}
              className="btn btn-link p-0 download-link"
              disabled={!loanAgreementId}
            >
              <i className="fa-solid fa-download me-1"></i> Download Loan Agreement
            </button>
          )}
          <div className="loan-id-badge">Loan ID: {displayLoanId}</div>
        </div>
      </div>

      {/* Metrics */}
      <div className="metrics-section">
        <div className="metric-item">
          <div className="metric-label">Loan Amount</div>
          <h3 className="metric-value">{displayLoanAmount}</h3>
        </div>
        <div className="metric-item">
          <div className="metric-label">Total Payable</div>
          <h3 className="metric-value">{displayTotalPayable}</h3>
        </div>
        <div className="metric-item">
          <div className="metric-label">Amount Paid</div>
          <h3 className="metric-value">{displayAmountPaid}</h3>
        </div>
        <div className="metric-item">
          <div className="metric-label">Outstanding Amount</div>
          <h3 className="metric-value text-red">{displayOutstanding}</h3>
        </div>
      </div>

      {/* Progress */}
      <div className="progress-section">
        <div className="progress-wrapper">
          <div className="progress-bar-container">
            <div
              className="progress-fill"
              style={{ width: `${percentage}%` }}
            ></div>
          </div>
          <div className="progress-text">{percentage}% Paid</div>
        </div>
        <p className="progress-subtext">
          {displayAmountPaid} paid of {displayTotalPayable}
        </p>
      </div>

      {/* Footer / Actions */}
      <div className="footer-section">
        <button className="btn btn-primary" onClick={onViewDetails} disabled={disableViewBtn}>
          View Details
        </button>
      </div>
    </div>
  );
};

export default ActiveLoanCard;
